module.exports = __webpack_public_path__ + "static/media/edit.9b14874e.svg";